import { computed, ref, useContext } from "@nuxtjs/composition-api"
import { getName } from "@cospired/i18n-iso-languages"

import { useLanguageQuery } from "@/api/query/languagesQuery"
import { Locale } from "@/types/models/Locale"

export interface LanguageName {
  id: string
  name: string
}

export default function () {
  const { app } = useContext()
  const locale = computed(() => app.i18n.locale.split("-")[0])

  useLanguageQuery({
    onSuccess(data) {
      formatLanguageNames(data)
    },
  })

  const getLangFullName = (langCodes: string[]) => {
    const langNames = langCodes.map((code) => getName(code, locale.value))

    return langNames
  }

  const allLanguageNames = ref<LanguageName[]>([])

  const formatLanguageNames = (locales: Locale[]) => {
    allLanguageNames.value = locales
      .filter((l) => l.enabled)
      .map((l) => {
        const languageName = getName(l.id, locale.value)
        return {
          id: l.id,
          name: languageName,
        } as LanguageName
      })
      .filter((l) => l.name !== undefined)
  }

  return { getLangFullName, allLanguageNames }
}
